import { z } from "zod";
import { galleryImageSchema } from "./gallery.ts";

export const subtitleTrackSchema = z.object({
  language: z.string(), // BCP-47
  label: z.string(),
  vttUrl: z.string().url(),
  default: z.boolean().optional(),
});
export type SubtitleTrack = z.infer<typeof subtitleTrackSchema>;

export const episodeSchema = z.object({
  _id: z.string(),
  seriesId: z.string(),
  // Default to 1 — most shows are single-season; backfill existed-before-r4 docs.
  seasonNumber: z.number().int().positive().default(1),
  episodeNumber: z.number().int().positive(),
  titleTh: z.string(),
  titleEn: z.string(),
  descriptionTh: z.string().optional(),
  descriptionEn: z.string().optional(),
  streamVideoId: z.string(),
  trailerStreamVideoId: z.string().optional(),
  durationSec: z.number().nonnegative(),
  // The primary thumbnail surfaced on cards. Admin uploads this in the wizard;
  // if they leave it blank, the wizard saves Cloudflare Stream's
  // auto-extracted default thumbnail URL as a fallback. Always user-overridable.
  thumbnailUrl: z.string().url(),
  // Additional episode photos — stills, extra thumbnails — surfaced in the
  // detail page and admin episode preview. Optional.
  gallery: z.array(galleryImageSchema).default([]),
  subtitles: z.array(subtitleTrackSchema).default([]),
  originalFilename: z.string().optional(),
  uploadedBy: z.string().optional(),
  uploadedAt: z.coerce.date().optional(),
  intro: z.object({ startSec: z.number(), endSec: z.number() }).optional(),
  credits: z.object({ startSec: z.number() }).optional(),
  episodePriceThb: z.number().nonnegative().nullable().optional(),
  isFreeOverride: z.boolean().nullable().optional(),
  published: z.boolean().default(false),
  releasedAt: z.coerce.date().optional(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type Episode = z.infer<typeof episodeSchema>;
